<template>
  <v-card class="text-center" variant="text">
    <v-icon color="primary" size="44"> mdi-timer-sand </v-icon>
    <v-card-text class="text-h6 pb-0">
      This task is currently pending in a calculation queue.
    </v-card-text>
    <v-card-text class="text-h6 pt-0">
      Please be patient, we will process your calculation soon.
    </v-card-text>
  </v-card>
</template>
